import { render } from "./iCountUp.vue?vue&type=template&id=429c5de6"
import script from "./iCountUp.vue?vue&type=script&lang=js"
export * from "./iCountUp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/Desktop/Project/jy-dashboard-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__